import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';
import { RateSegmentInfo } from 'global/utils/RateSegmentHelper';
import { breakpoints } from '@insurancemenu/imenu-components-lib/dist/utils';
import { createUseStyles } from 'react-jss';

// Props aren't used, but prevent errors
const styles: ComponentStylesProps<RateSegmentInfo> = {
  listWrapper: {
    position: 'relative',
    minHeight: '50rem',
  },
  cardsList: {
    display: 'grid',
    padding: 0,
    listStyle: 'none',
    gridTemplateColumns: 'repeat( auto-fit, minmax(20rem, 30rem))',
    gap: '2rem',
    justifyContent: 'center',
    margin: '0 auto',
    '@media(max-width:1400px)': {
      gap: '4rem',
    },
  },

  [breakpoints.md.down]: {
    // MAKE IT ONLY AS FUNCTION, otherwise styles will not be applied
    cardsList: () => ({
      gridTemplateColumns: '30rem',
    }),
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
